import { render, staticRenderFns } from "./ChooseBottleProperties.vue?vue&type=template&id=8a3fb806&"
import script from "./ChooseBottleProperties.vue?vue&type=script&lang=js&"
export * from "./ChooseBottleProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports